export default __webpack_public_path__ + "static/media/tablet-sm.a42d442a.png";